import Vue from 'vue';
import numberToCurrency from './numberToCurrency';
import capitalizeText from './capitalizeText';

Vue.filter('capitalizeText', capitalizeText);
Vue.filter('numberToCurrency', numberToCurrency);
